import React from 'react';

const path = 'oldPages/return-mail/index.html';

function ReturnMail() {
  return <iframe title="return-mail" src={path} width="100%" height="2000px" />;
}

export default ReturnMail;
